import { render, staticRenderFns } from "./scratchGui.vue?vue&type=template&id=3b278936&scoped=true"
import script from "./scratchGui.vue?vue&type=script&lang=js"
export * from "./scratchGui.vue?vue&type=script&lang=js"
import style0 from "./scratchGui.vue?vue&type=style&index=0&id=3b278936&prod&scoped=true&lang=scss"
import style1 from "./scratchGui.vue?vue&type=style&index=1&id=3b278936&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b278936",
  null
  
)

export default component.exports